import { useTranslation } from "react-i18next";
import "./style.css";
import ActionBtn from "@/components/ActionBtn";
import SideCol from "../../../shared/SideCol/SideCol";
import { SideSection } from "../../../shared/SideCol/SideSection";
import { useContext } from "react";
import { errorToast, successToast } from "@/utils/toasters";
import { DomainContext } from "@/context/DomainContext";
import { AMAcceptQuotation } from "@/api/endpoints";

const QuotationSummary = ({ selectedHospital, quotationData, fetchData }) => {
  const { t } = useTranslation();
    const { setLoading } = useContext(DomainContext)

  const handleAMAcceptQuotation = async () => {
    setLoading((l) => l + 1)
    await AMAcceptQuotation(quotationData?.orderId).then((res) => {
      successToast("accepted successfully");
      fetchData()
    }).catch((err) => {
      errorToast(err?.response?.data?.message);
    }).finally(() => {
      setLoading((l) => l - 1)
    })
  };


  return (
    <SideCol
      className="qs-sidebar"
      title={t("quotation-summary")}
      icon="solar:shield-check-outline"
    >
      <SideSection
        title={t("base-medical-fee")}
        value={`${selectedHospital?.price || 0} $`}
      />
      <div className="qs-divider" />
      <SideSection
        title={t("total-journey-price")}
        value={`${selectedHospital?.price || 0} $`}
      />
     

      <ActionBtn
        onApply={handleAMAcceptQuotation}
        title={t("finalize-notify")}
        icon="tabler:send"
        className="w-100 rounded mb-3"
        isDisabled={quotationData?.isVerified}
      />

      
    </SideCol>
  );
};

export default QuotationSummary;
